import {
  CourseBundleCreateApiInterface,
  CourseBundleEditApiInterface,
  CourseBundleItemInterface,
} from 'modules/courses/bundles/types/course-bundle-interface'
import httpClient from 'shared/utils/http-client'

export const COURSE_BUNDLES_API = '/api/dashboard/customer/membership/course-bundles'

export const createCourseBundle = (data: CourseBundleCreateApiInterface) =>
  httpClient.post<CourseBundleItemInterface>(COURSE_BUNDLES_API, data)

export const updateCourseBundle = (id: number, data: CourseBundleEditApiInterface) =>
  httpClient.put<CourseBundleItemInterface>(`${COURSE_BUNDLES_API}/${id}`, data)

export const removeCourseBundle = (id: number) => httpClient.delete(`${COURSE_BUNDLES_API}/${id}`)

export const activateCourseBundle = (update: 'deactivate' | 'activate', id: number) =>
  httpClient.post<CourseBundleItemInterface>(`${COURSE_BUNDLES_API}/${id}/${update}`)
